module.exports = __webpack_public_path__ + "img/onboarding_guide1.bc23d9fe.jpeg";